<template>
    <vue-good-table
        compactMode
        fixedHeader
        ref="SimpleTable"
        :columns="fields"
        :rows="items"
        styleClass="vgt-table condensed vgt-table fixed-header"
    >
    <template slot="table-row" slot-scope="props">
        <span v-if="props.column.cell == 'formatMoney'">
            {{ commafy(props.row[props.column.field]) }}
        </span>
        <span v-else-if="props.column.cell == 'formatPrice'">
            {{ commafy(props.row[props.column.field], 4) }}
        </span>
        <span v-else-if="props.column.cell == 'formatBool'">
            <span v-if="props.row[props.column.field]">YES</span>
            <span v-else>NO</span>
        </span>
        <span v-else-if="props.column.cell == 'formatLink'">
            <span v-if="props.column.route != ''">
                <a class="report-link" @click="navigateLink(props.column.route, props.row[props.column.field])">{{ props.row[props.column.field] }}</a>
            </span>
            <span v-else>
                {{ props.row[props.column.field] }}
            </span>
        </span>
        <span v-else>
            {{ props.row[props.column.field] }}
        </span>
    </template>
    </vue-good-table>    
</template>
<script>
import 'vue-good-table/dist/vue-good-table.css';
import {VueGoodTable} from 'vue-good-table';

export default {
    components: {
        VueGoodTable
    },
    props: {
        fields: [Array],
        items: [Array]
    },
    methods: {
        commafy(num, decimal = 2) {
            try {
                if (num != null) {
                var str = num.toString().split('.');
                if (str[0].length >= 3) {
                    str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
                }
                if (str[1]) {
                    if (str[1].length < decimal) {
                    while (str[1].length < decimal) { str[1] = str[1] + "0"; }
                    } else if (str[1].length > decimal) {
                    str[1] = str[1].substring(0, decimal)
                    }
                }
                return str.join('.');
                }
            } catch {
                return num;
            }
        },
        navigateLink(route, value) {
            let routeData = this.$router.resolve({ name: route, params: {id: value} })
            window.open(routeData.href, '_blank');
        },
    }
}
</script>